<template>
  <div class="get-in-touch">
    <form class="get-in-touch-form" @submit.prevent="sendQuestion()">
      <div class="row">
        <div class="col-sm-6 col-12">
          <default-input
            v-model="get_in_touch.email"
            :placeholder="$t('input_placeholder.e_mail_short')"
            name="email"
            type="email"
            required
            maxlength="150"
          />
        </div>
        <div class="col-sm-6 col-12">
          <default-input
            v-model="get_in_touch.city"
            :placeholder="$t('input_placeholder.city')"
            name="city"
            type="text"
            maxlength="150"
          />
        </div>
        <div class="col-12">
          <default-textarea
            :key="componentKey"
            required
            :placeholder="$t('input_placeholder.feedback_here')"
            v-model="get_in_touch.feedback"/>
        </div>
      </div>

      <div class="mt-40 mt-xs-20">
        <label class="terms-checkbox">
          <input required type="checkbox"
                 :value="agreeded"
                 v-model="agreeded"
                 @input="$emit('input', $event.target.checked)">
          <span v-html="`${$t('text.terms')}*`"/>
        </label>
      </div>
      <div class="mt-20">
        <default-button
          class="get-in-touch-form__submit"
          type="submit">
          {{ $t('btn.submit') }}
        </default-button>
      </div>
    </form>
    <form-submitting-popup
      ref="form_submitting_modal"
      :title="$t('text.contact_us_submit_title')"
      :body="$t('text.contact_us_submit_text')"
    />
  </div>
</template>

<script>
import {axiosCustomerQuestion} from "../../../admin/helpers/axios_requests";
import {NEW_CUSTOMER_QUESTION} from "../../helpers/new_objects";
import DefaultInput from "../small_parts/DefaultInput.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import FormSubmittingPopup from "../modals/FormSubmittingPopup.vue";
import DefaultTextarea from "../small_parts/DefaultTextarea.vue";
import TermsCheckbox from "../small_parts/TermsCheckbox.vue";

export default {
  name: "GetInTouchForm",
  components: {
    TermsCheckbox,
    DefaultTextarea,
    FormSubmittingPopup,
    DefaultButton,
    DefaultInput
  },
  data() {
    return {
      get_in_touch: [],
      agreeded: false,
      componentKey: 0
    }
  },
  created() {
    this.$set(this, 'get_in_touch', NEW_CUSTOMER_QUESTION())
  },
  methods: {
    sendQuestion() {
      if (!this.agreeded) {
        alert(this.$t('text.agree_confirm'));
        return;
      }
      axiosCustomerQuestion.send(this.get_in_touch)
        .then(r => {
          this.showSubmittedModal()
          this.agreeded = false;
          this.get_in_touch = NEW_CUSTOMER_QUESTION()
          this.componentKey += 1;
        })
        .catch(e => {
          console.log(e.response.status);
        })
    },
    showSubmittedModal() {
      this.$refs.form_submitting_modal.openModal(true);
    },
  }
}
</script>
